/**
 * Disclosure Types Enum
 * Defines the types of disclosure/legal documents that can be displayed
 */
export enum DisclosureType {
  TERMS_OF_USE = 'termsOfUse',
  CONFIRMATION_RELEASE = 'confirmationRelease',
  ELECTRONIC_DOCUMENTS = 'electronicDocuments',
}
